export default function ErrorCard({ message }) {
  return <div className="result-card error-card">{message}</div>;
}
